'use strict';
var base = require('./base');
var focusHelper = require('../components/focus');

/**
 * Generates the modal window on the first call.
 *
 */
function getModalHtmlElement() {
    if ($('#quickViewModal').length !== 0) {
        $('#quickViewModal').remove();
    }
    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="quickViewModal" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog quick-view-dialog">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <span>EXPRESS PURCHASE</span>'
        + '    <button type="button" class="close pull-right" data-dismiss="modal">'
        + '        <i class="icon icon-cross"></i>'
        + '        <span class="sr-only"> </span>'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '<div class="modal-footer"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
}

/**
 * @typedef {Object} QuickViewHtml
 * @property {string} body - Main Quick View body
 * @property {string} footer - Quick View footer content
 */

/**
 * Parse HTML code in Ajax response
 *
 * @param {string} html - Rendered HTML from quickview template
 * @return {QuickViewHtml} - QuickView content components
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.product-quickview');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

/**
 * Sanitize Slick carousel accessibility markup:
 * - Remove wrong tab roles
 * - Normalize dots and slides for screen readers
 *
 * @param {Object} slick - Slick carousel instance passed from the event callback
 */
function sanitizeSlickAccessibility(slick) {
    if (!slick) return;

    if (slick.$slides && slick.$slides.length) {
        slick.$slides.each(function (i, slide) {
            if (slide.getAttribute('role') === 'tabpanel') {
                slide.removeAttribute('role');
            }
            const isCurrent = (i === slick.currentSlide);
            slide.setAttribute('aria-hidden', isCurrent ? 'false' : 'true');
        });
    }

    if (!slick.$dots) return;

    // Container should not be a tablist
    slick.$dots.removeAttr('role').attr({
        role: 'group',
        'aria-label': 'Carousel slide navigation'
    });

    // Each dot: remove tab role
    slick.$dots.find('li').removeAttr('role');
    slick.$dots.find('button').each(function (i, btn) {
        btn.removeAttribute('role');
        btn.removeAttribute('aria-selected');
        btn.removeAttribute('tabindex');
        btn.setAttribute('aria-label', `Go to slide ${i + 1} of ${slick.slideCount}`);
        btn.setAttribute('aria-current', slick.currentSlide === i ? 'true' : 'false');
        btn.setAttribute('aria-controls', `slick-slide0${i}`);
    });
}

/**
 * Init Slick Carousel.
 *
 */
function initCarousel() {
    var slickMainCarousel = $('.product-quickview').find('.js-product-main-carousel');

    if ($(slickMainCarousel).hasClass('slick-initialized')) {
        $(slickMainCarousel).slick('unslick');
    }


    $(slickMainCarousel).on('init reInit afterChange breakpoint setPosition', function (e, slick) {
        sanitizeSlickAccessibility(slick);
    });

    $(slickMainCarousel).slick({
        accessibility: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: false,
        dots: true,
        infinite: false
    });
}

/**
 * replaces the content in the modal window on for the selected product variation.
 * @param {string} selectedValueUrl - url to be used to retrieve a new product model
 */
function fillModalElement(selectedValueUrl) {
    $('.modal-body').spinner().start();
    $.ajax({
        url: selectedValueUrl,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            var parsedHtml = parseHtml(data.renderedTemplate);

            $('.modal-body').empty();
            $('.modal-body').html(parsedHtml.body);
            $('.modal-footer').html(parsedHtml.footer);
            $('.full-pdp-link').text(data.quickViewFullDetailMsg);
            $('#quickViewModal .full-pdp-link').attr('href', data.productUrl);
            $('#quickViewModal .size-chart').attr('href', data.productUrl);
            $('#quickViewModal .modal-header .close .sr-only').text(data.closeButtonText);
            $('#quickViewModal .enter-message').text(data.enterDialogMessage);
            $('#quickViewModal').modal('show');

            $('body').trigger('quickview:ready');

            let createCarousel = setTimeout(() => {
                initCarousel();

                if ($('.js-product-main-carousel img').height() !== 0) {
                    clearTimeout(createCarousel);
                }
            }, 300);

            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

module.exports = {
    showQuickview: function () {
        $('body').on('click', '.quickview', function (e) {
            e.preventDefault();
            var selectedValueUrl = $(this).data('href');
            $(e.target).trigger('quickview:show');
            getModalHtmlElement();
            fillModalElement(selectedValueUrl);
        });
    },
    focusQuickview: function () {
        $('body').on('shown.bs.modal', '#quickViewModal', function () {
            $('#quickViewModal .close').focus();
            if ($('.js-notify-me').length > 0 && $('.size-attribute').length === 1) {
                const { notifyMeButton, notifyMeForm } = require('./backInStock');
                notifyMeButton();
                notifyMeForm();
            }
        });
    },
    trapQuickviewFocus: function () {
        $('body').on('keydown', '#quickViewModal', function (e) {
            var focusParams = {
                event: e,
                containerSelector: '#quickViewModal',
                firstElementSelector: '.full-pdp-link',
                lastElementSelector: '.add-to-cart-global',
                nextToLastElementSelector: '.modal-footer .quantity-select'
            };
            focusHelper.setTabNextFocus(focusParams);
        });
    },
    availability: base.availability,
    addToCart: base.addToCart,
    showSpinner: function () {
        $('body').on('product:beforeAddToCart', function (e, data) {
            $(data).closest('.modal-content').spinner().start();
        });
    },
    hideDialog: function () {
        $('body').on('product:afterAddToCart', function () {
            $('#quickViewModal').modal('hide');
        });
    },
    beforeUpdateAttribute: function () {
        $('body').on('product:beforeAttributeSelect', function () {
            $('.modal.show .modal-content').spinner().start();
        });
    },
    updateAttribute: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if ($('.modal.show .product-quickview>.bundle-items').length) {
                $('.modal.show').find(response.container).data('pid', response.data.product.id);
                $('.modal.show').find(response.container)
                    .find('.product-id').text(response.data.product.id);
            } else if ($('.set-items').length) {
                response.container.find('.product-id').text(response.data.product.id);
            } else {
                $('.modal.show .product-quickview').data('pid', response.data.product.id);
                $('.modal.show .full-pdp-link')
                    .attr('href', response.data.product.selectedProductUrl);
            }
        });
    },
    updateAddToCart: function () {
        $('body').on('product:updateAddToCart', function (e, response) {
            // update local add to cart (for sets)
            if (!$('button.add-to-cart', response.$productContainer).hasClass('disabled-btn')) {
                $('button.add-to-cart', response.$productContainer).attr('disabled',
                (!response.product.readyToOrder || !response.product.available));
            }

            // update global add to cart (single products, bundles)
            var dialog = $(response.$productContainer)
                .closest('.quick-view-dialog');

            if ($('.add-to-cart-global', dialog).hasClass('disabled-btn')) {
                $('.product-error').remove();
            }

            if (response.product.readyToOrder && response.product.available) {
                $('.add-to-cart-global', dialog).removeClass('disabled-btn');
            } else {
                $('.add-to-cart-global', dialog).addClass('disabled-btn');
            }
        });
    },
    updateAvailability: function () {
        $('body').on('product:updateAvailability', function (e, response) {
            const { notifyMeButton, notifyMeForm } = require('./backInStock');
            // bundle individual products
            $('.product-availability', response.$productContainer)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available)
                .find('.availability-msg')
                .empty()
                .html(response.message);


            var dialog = $(response.$productContainer)
                .closest('.quick-view-dialog');

            if ($('.product-availability', dialog).length) {
                // bundle all products
                var allAvailable = $('.product-availability', dialog).toArray()
                    .every(function (item) { return $(item).data('available'); });

                var allReady = $('.product-availability', dialog).toArray()
                    .every(function (item) { return $(item).data('ready-to-order'); });

                $('.global-availability', dialog)
                    .data('ready-to-order', allReady)
                    .data('available', allAvailable);

                $('.global-availability .availability-msg', dialog).empty()
                    .html(allReady ? response.message : response.resources.info_selectforstock);
            } else {
                // single product
                $('.global-availability', dialog)
                    .data('ready-to-order', response.product.readyToOrder)
                    .data('available', response.product.available)
                    .find('.availability-msg')
                    .empty()
                    .html(response.message);
            }

            notifyMeButton();
            notifyMeForm();
        });
    },
    initCarousel: initCarousel
};
